import React, { useState } from 'react';
import { Button, Typography, Grid, Switch } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import CopyToClipboard from './CopyToClipboard';

export default function CodeDialog(props) {
  let { creative } = props;
  const [pps, setPPS] = useState(false);
  const [advId, setAdvId] = useState(window.localStorage.getItem('adv_id'));
  const [campaign, setCampaign] = useState(window.localStorage.getItem('campaign'));
  const [deepLink, setDeepLink] = useState(true);

  function handlePPS() {
    setPPS(!pps);
  }

  function handleDeepLink() {
    setDeepLink(!deepLink);
  }
  const changeAdvId = event => {
    setAdvId(event.target.value);
    window.localStorage.setItem('adv_id', event.target.value);
  };

  const changeCampaign = event => {
    setCampaign(event.target.value);
    window.localStorage.setItem('campaign', event.target.value);
  };

  const CustomSwitch = withStyles({
    switchBase: {
      color: 'lightgreen',
      '&$checked': {
        color: 'lightblue',
      },
      '&$checked + $track': {
        backgroundColor: 'lightblue',
      },
    },
    checked: {},
    track: {},
  })(Switch);

  const getLinkingCode = creative => {
    if (!creative || !advId) return 'Please Enter Your AdvId';
    let { LinkingCode, SceneID, CustomParam } = creative;

    //if we have nodeeplink in CustomParam
    if (CustomParam && CustomParam.includes('nodeeplink') && deepLink) {
      setDeepLink(false);
    }

    let SubProgramId = pps ? 2 : 1;
    LinkingCode += `&su=${SubProgramId}&ad=${advId}`;

    if (campaign !== '' && campaign !== null) {
      LinkingCode += `&acampaign=${campaign}`;
    }

    if (SceneID && deepLink) {
      LinkingCode += `&pa=clip&ar=${SceneID}`;
    }
    if (CustomParam) {
      LinkingCode += `&${CustomParam}`;
    }
    return LinkingCode;
  };
  const buildCode = creative => {
    if (!creative || !advId) return 'Please Enter Your AdvId';

    let { CreativeURL, ProgramType, Width, Height } = creative;
    let LinkingCode = getLinkingCode(creative);
    if (ProgramType === "Legacy")
      return `<a href="${LinkingCode}" target="_blank" style=" position:relative; display:inline-block; line-height:0;"><div class="blocker" style=" position:absolute; height:100%; width:100%; z-index:1;"></div><img src="${CreativeURL}" width="${Width}" height="${Height}" style="z-index: 2"/></a>'`;
    return `<a href="${LinkingCode}" target="_blank" style=" position:relative; display:inline-block; line-height:0;"><div class="blocker" style=" position:absolute; height:100%; width:100%; z-index:1;"></div><iframe src="https://cdn.banhq.com${CreativeURL}" width="${Width}" height="${Height}" frameborder="0" scrolling="no" style="z-index: 2"></iframe></a>'`;
  };
  return (
    <div>
      <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="lg">
        <DialogTitle id="form-dialog-title" onClose={props.onClose}>
          Get Code for {creative ? creative.CreativeName : ''}
        </DialogTitle>
        <DialogContent>
          <Grid container alignItems="center" spacing={4}>
            <Grid item>
              <TextField
                id="outlined-number"
                label="adv_id"
                value={advId}
                onChange={changeAdvId}
                type="number"
                InputLabelProps={{ shrink: true }}
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <TextField
                id="outlined-number"
                label="campaign"
                placeholder="Optional"
                value={campaign}
                onChange={changeCampaign}
                type="text"
                InputLabelProps={{ shrink: true }}
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <Typography>
                Revshare
                <CustomSwitch checked={pps} onChange={handlePPS} value={pps} />
                PPS
              </Typography>
            </Grid>
            {creative && creative.SceneID > 0 && (
              <Grid item>
                <Typography>
                  DeepLink
                  <Switch
                    checked={deepLink}
                    onChange={handleDeepLink}
                    value={pps}
                  />
                </Typography>
              </Grid>
            )}
          </Grid>
          <TextField
            id="outlined-multiline-flexible"
            label="Code"
            multiline
            rows={6}
            disabled
            //rowsMax="4"
            value={buildCode(creative)}
            //onChange={handleChange('multiline')}
            margin="dense"
            variant="outlined"
            fullWidth
          />
          <DialogContentText>
            Always{' '}
            <a href={getLinkingCode(creative)} target="_blank">
              test
            </a>{' '}
            the generated code to make sure it's lnking to the right
            destination.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CopyToClipboard>
            {({ copy }) => (
              <Button
                variant="contained"
                color="primary"
                onClick={() => copy(buildCode(creative))}
              >
                Copy Code
              </Button>
            )}
          </CopyToClipboard>
          <Button onClick={props.onClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CodeDialog.js